import React, { Component } from "react";
import { Route } from "react-router";
import Home from "./components/Home";
import Track from "./components/Track";
// Site-wide global styles (Bootstrap etc.)
import "./assets/styles/index.scss";
import LazyBackground from "./components/LazyBackground";

export default class App extends Component {
    static displayName = App.name;

    componentDidMount() {}

    render() {
        return (
            <LazyBackground
                bgposition="center center"
                bgrepeat="no-repeat"
                bgsize="cover"
                src={require(`./assets/images/freight-people-home-bg.jpg`)}
                placeholder={require(`./assets/images/freight-people-home-bg-blurred.jpg`)}
                className="d-flex flex-column flex-grow-1 h-100"
            >
                <Route exact path="/" component={Home} />
                <Route exact path="/track/:trackingId" component={Track} />
            </LazyBackground>
        );
    }
}
